/*
  Adaptive height for the product mobile slider.

  .product__mobile-slider-track is a scroll-snap flex row, so it is as tall as
  its tallest slide and a shorter slide leaves dead space beneath it. This sizes
  the track to whichever slide is snapped into view, and updates on slide change.
*/
(function () {
  if (window.__mobileSliderHeightInit) return;
  window.__mobileSliderHeightInit = true;

  var TRACK = '.product__mobile-slider-track';
  var currentIndex = new WeakMap();
  var frame = null;

  function tracks() {
    return Array.prototype.slice.call(document.querySelectorAll(TRACK));
  }

  function visibleSlides(track) {
    // The slider is hidden on desktop, and slides can be hidden individually,
    // so measure only what is actually laid out.
    return Array.prototype.filter.call(track.children, function (el) {
      return el.getBoundingClientRect().width > 0;
    });
  }

  function measure(track, slide) {
    // Release the height we set before reading, so a slide cannot report back
    // the value we just gave it. Same frame, so nothing paints in between.
    var previous = track.style.height;
    track.style.height = '';
    var height = slide.offsetHeight;
    track.style.height = previous;
    return height;
  }

  function sizeTrack(track, force) {
    if (!track.offsetWidth) return;

    var slides = visibleSlides(track);
    if (slides.length < 2) {
      track.style.height = '';
      return;
    }

    var index = Math.round(track.scrollLeft / track.offsetWidth);
    index = Math.min(Math.max(index, 0), slides.length - 1);

    // Only remeasure when the slide actually changes; scroll fires constantly
    // and reading offsetHeight forces layout.
    if (!force && currentIndex.get(track) === index) return;
    currentIndex.set(track, index);

    var height = measure(track, slides[index]);
    if (height) track.style.height = height + 'px';
  }

  function schedule(force) {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      tracks().forEach(function (track) {
        sizeTrack(track, force === true);
      });
    });
  }

  function start() {
    tracks().forEach(function (track) {
      track.addEventListener('scroll', function () {
        schedule(false);
      }, { passive: true });

      // Images settle after layout; remeasure once each one has real height.
      Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
        if (!img.complete) {
          img.addEventListener('load', function () {
            schedule(true);
          }, { once: true });
        }
      });
    });

    window.addEventListener('resize', function () {
      schedule(true);
    }, { passive: true });

    // Slides can be shown or hidden at runtime by a class on the root element,
    // which changes what needs measuring.
    new MutationObserver(function () {
      schedule(true);
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    schedule(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
